/** @jsx jsx */
import { jsx } from '@emotion/react';
import { createContext, useContext } from 'react';
export const defaultAnnouncementContext = {
    t: (v) => v,
    announcementDateFormatter: (date) => {
        return new Date(date * 1000).toLocaleDateString('en-US');
    },
    defaultAvatar: (jsx("img", { src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAACKUExURUdwTBwAYxsAXx8AXxwAYhsAYw8Abx0AYhwAYx8AXxwAYhwAYx0AYhcAZxwAYR4AYh0AYx0AYxsAYw8AXxwAYhwAYhsAYR0AYxwAYhsAYR0AZBwAYx0AYR8AXxwAYxwAYhwAYhoAXx0AYhwAYh4AYh8AZBwAXx0AYhwAYR8AZxoAZBsAZBwAYR0AY3XrJ/UAAAAtdFJOUwCQQBDfQBC/7yDv328gkH/vr4AQUKCAX79wT89wMJ+wzzBgf48wUM+fIDBwoLjFRcUAAAFwSURBVEjH7VbXYoMwDBRhmF1CGC0kTZvuof//vRobagMykOf2XgBxOnRCNgD8YwFezFiynb6zfESMtorfvKHENnGGAx62iPuocH+FuMDdIvukxMP+6C42UQnnH9mKZ9nEHrdB0soztkEcwy9Iov48JcX3elvQsuFz4GOz0kREh7usVehxpYlhbgPE6tpfFO/M8vCTFtA8e68TcS5fdzfe9VBFNlGZ5TrtKDa8tv2MLcyCamePQ58wo4c5UHxnqCgPCbO80GmdZ+XZLR0lX8hYPHvweFRf+nkQZiftNI2qfSmzYR6f5/xfzzpSKeMRjaOXpysGMmkJvmF5Zt1GElF8rMmEbwwgIPmzUZUoePN2JN+nV5udMZ5EwbA8gfmHI5mQGhKO2KRycqxxQmNIsDEVL8Hh5h09IQBjTZHkAwTlqmeOCge+KJAY1QkCjQ+qrMq8STIMT5ona3VXBdceXV4y06gai+RlWdd9Dwv3j/8Q/AC7vn41wHB8TgAAAABJRU5ErkJggg==", css: {
            width: '24px',
            height: '24px',
        } })),
    title: 'Telegram',
    subtitle: '',
};
const AnnouncementContext = createContext(defaultAnnouncementContext);
export const useAnnouncementContext = () => {
    return useContext(AnnouncementContext);
};
export const AnnouncementConfigProvider = ({ children, ...props }) => {
    return (jsx(AnnouncementContext.Provider, { value: {
            ...defaultAnnouncementContext,
            ...props,
        } }, children));
};
